import { WaterCogeneration } from '../../../_unit-operations/utilties/water-cogeneration';
import { SimulationVariable } from '../../../simulation-variable';
import { SimulationVariableName } from '../../../../_config/simulation-variable-name.enum';
import { ConstraintReportVariable } from '../constraint-report-variable';

export class WaterCogenerationConstraintReportVariableResolver {
  static create() {
    return new WaterCogenerationConstraintReportVariableResolver();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  addCurrentValueAndUnitToConstraintReportVariable(
    crv: ConstraintReportVariable,
    params: { uo: WaterCogeneration; simVar: SimulationVariable }
  ): void {
    const { uo, simVar } = params;

    const inletStreamsList = uo.ownerCase.filterWaterMaterialStreams(s => {
      return s.outletUnitOperationId === uo.id;
    });

    if (!inletStreamsList.length) {
      return;
    }

    if (simVar.name === SimulationVariableName.MAXIMUM_FEED_CAPACITY) {
      crv.currentValue = inletStreamsList[0].massFlowrate.convertToDefaultUnit(true, false);
      crv.currentUnit = inletStreamsList[0].massFlowrate.getDefaultUnit();
      return;
    }

    if (simVar.name === SimulationVariableName.MINIMUM_MASS_FLOWRATE) {
      crv.currentValue = inletStreamsList[0].massFlowrate.convertToDefaultUnit(true, false);
      crv.currentUnit = inletStreamsList[0].massFlowrate.getDefaultUnit();
      return;
    }

    throw new Error(`Unknown constraint: ${simVar.name}`);
  }
}
